import React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from 'src/component/ds/utils';
import { DsThemedPortal } from 'src/component/ds/DsRoot';

/* "Tooltip - Vega" in Figma. TooltipProvider must wrap any tree using tooltips. */

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, collisionPadding = 8, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <DsThemedPortal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          'ds-z-50 ds-overflow-hidden ds-px-2 ds-py-1',
          'ds-rounded-ds ds-bg-primary ds-text-primary-foreground ds-text-ds-mini',
          'ds-shadow-ds-sm',
          'ds-max-w-[280px] ds-text-balance',
          'data-[state=delayed-open]:ds-animate-in data-[state=closed]:ds-animate-out',
          'data-[state=delayed-open]:ds-fade-in-0 data-[state=closed]:ds-fade-out-0',
          className
        )}
        {...props}
      />
    </DsThemedPortal>
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
